import type {
  SharableOpportunitiesQuery,
  SharableOpportunitiesResponse,
  SharableOpportunityDetailResponse,
} from 'backend/types'
import { apiFetch } from '..'

/**
 * 共有可能案件一覧取得API
 *
 * @param query - クエリパラメータ（onlyRelease, offset, limit）
 * @returns 共有可能案件一覧レスポンス
 * @throws ApiError - 認証失敗（403）、権限不足（403）、サーバーエラー（500）
 */
export async function getSharableOpportunities(
  query?: Partial<SharableOpportunitiesQuery>,
): Promise<SharableOpportunitiesResponse> {
  // クエリパラメータを構築
  const params = new URLSearchParams()
  if (query?.onlyRelease !== undefined) {
    params.append('onlyRelease', query.onlyRelease ? 'true' : 'false')
  }
  if (query?.offset !== undefined && query.offset !== null) {
    params.append('offset', query.offset.toString())
  }
  if (query?.limit !== undefined && query.limit !== null) {
    params.append('limit', query.limit.toString())
  }

  const queryString = params.toString()
  const url = `/api/sharable-opportunities${queryString ? `?${queryString}` : ''}`

  return apiFetch<SharableOpportunitiesResponse>(url, { method: 'GET' })
}

/**
 * 共有可能案件詳細取得API
 *
 * @param id - 公開オポチュニティID
 * @returns 共有可能案件詳細レスポンス
 * @throws ApiError - 認証失敗（403）、権限不足（403）、見つからない（404）、サーバーエラー（500）
 */
export async function getSharableOpportunityDetail(id: number): Promise<SharableOpportunityDetailResponse> {
  return apiFetch<SharableOpportunityDetailResponse>(`/api/sharable-opportunity/${id}`, { method: 'GET' })
}
